---
title: Terms of Service
lastUpdated: 31 July 2026
lead: The terms that apply when you join the Tiny Boss waitlist.
---

## Where We're At

Tiny Boss is currently in early access, and this site exists to let you
join the waitlist. These terms cover your use of this website and the
waitlist signup — they'll be replaced with fuller terms once the app
itself is publicly available.

By using this site or joining the waitlist, you agree to these terms. If
you don't agree, please don't use the site.

## Who Can Sign Up

You must be at least 18 years old, or the age of legal majority where you
live, to join the waitlist. By signing up, you're confirming that's true.

## Joining the Waitlist

Signing up gives you no guarantee of access, and no guarantee of a
specific timeline — early access invitations go out at our discretion. We
may change, pause, or end the waitlist or early access at any time.

Give us an email address you actually check, and keep it accurate. You can
unsubscribe at any time using the link in any email we send, or by writing
to [hey@tinybossapp.com](mailto:hey@tinybossapp.com).

## Acceptable Use

Don't use this site to do anything unlawful, to try to disrupt or gain
unauthorized access to it, or to harass us or anyone else through it.

## Our Content

The Tiny Boss name, logo, and the content on this site (text, graphics,
and design) belong to us and may not be copied or reused without our
permission, except as needed to view the site normally in your browser.

## No Warranty

This site and the waitlist are provided "as is," without warranties of any
kind. We don't guarantee the site will be uninterrupted, error-free, or
that joining the waitlist will lead to access to Tiny Boss.

## Limitation of Liability

To the fullest extent the law allows, Tiny Boss isn't liable for any
indirect, incidental, or consequential damages arising from your use of
this site or the waitlist.

## Changes to These Terms

We may update these terms as the site and the waitlist evolve. If we make
a meaningful change, we'll update the date at the top of this page.
Continuing to use the site after a change means you accept the updated
terms.

## Governing Law

These terms are governed by the laws of the State of Delaware, USA,
without regard to its conflict-of-law rules.

## Questions?

Reach us any time at [hey@tinybossapp.com](mailto:hey@tinybossapp.com).
